import React from 'react';
import styled from 'styled-components';
import format from 'date-fns/format';

const SurveyStatus = ({ statusText, title, completedOn, variant = 'success' }) => {
  const formattedDate = completedOn
    ? format(new Date(completedOn), "EEEE, MMM do h:mm a")
    : null;

  const emojiMap = {
    success: { emoji: '🎉', label: 'celebration' },
    error: { emoji: '❌', label: 'error' },
    warning: { emoji: '⚠️', label: 'warning' },
    info: { emoji: 'ℹ️', label: 'info' },
  };

  const { emoji, label } = emojiMap[variant] || emojiMap.success;

  return (
    <FeedbackContainer>
      <Emoji><span role="img" aria-label={label}>{emoji}</span></Emoji>
      <QuestionText>{title}</QuestionText>
      <Description>
        {statusText}
        {formattedDate ? ` on ${formattedDate}.` : '.'}
      </Description>
    </FeedbackContainer>
  );
};

export default SurveyStatus;

const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width:100%;
  max-width:600px;
  font-family: 'Raleway', sans-serif;
`;

const QuestionText = styled.h2`
  margin-bottom: 1rem;
  color:#2A3039;
  font-size: 20px;
  font-weight: 600;
`;

const Description = styled.div`
  color: #2A3039;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  margin-bottom:26px;
  line-height: 150%;
`;

const Emoji = styled.div`
  font-size: 48px;
  margin-bottom:24px;
`;
